import React,{Fragment} from 'react';
import styles from '../../../../styles/modules/ui-components/ui-textfield.module.scss';
import { validateInput } from '../../../../utils';

interface UITextFieldProps {

    label:string,
    id?:string,
    onChange:any,
    onBlur?:(e:React.ChangeEvent) => void,
    hasError?:boolean,
    isRequired?:boolean,
    isDisabled?:boolean,
    regExp?:any,
    inputAttr?:object,
    error?:string,
    noPlaceholder?:boolean | false,
    customValidation?:(e) => { isValid:boolean,msg?:string},
    value?:string,
    className?:string,
    propsError?: string,
    isAutoFocus?:boolean | false,
    minHeight?:any,
    characterLimit?:number
}

interface UITextFieldState {
    isvalid:unknown,
    required?:boolean,
    errortext?:unknown,
    value?:string,
}

class  UITextField extends React.Component<UITextFieldProps,UITextFieldState> {
    constructor(props) {
        super(props);
        this.state = {
            isvalid:this.props.hasError || true,
            required:this.props.isRequired || false,
            errortext:this.props.error || null,
            value:this.props.error || '',
        }
    }

    static getDerivedStateFromProps = (props:any, state:any) =>{
      if(state.value !== props.value) {
        let data = {value:props.value}
        if(props.value && state.errortext && state.errortext.toString().toLowerCase()=="required field"){
            data['errortext'] = null
        }
        return data
      }
      if(props.error && state.errortext !== props.error) {
        return {
          errortext:props.error
        }
      }
      return null
    }

    mathRegExp = (value:string) => {
        let regExp = this.props.regExp;
        if(!value.match(regExp)) {
            return false;
        }
        else {
            return true;
        }
    }
    checkIsValueValid = (e:any) => {

        let value = e.target.value.trim(),
            regExp = this.props.regExp;

        if(this.state.required) {

            if(!value) {
                this.setState(
                    {
                        isvalid:false ,
                        errortext:'required field'
                    }
                );
                return false;
            }
        }
        else {
            this.setState(
                {
                    isvalid:true,
                    errortext:null
                }
            );
            if(this.props.onBlur) {

                this.props.onBlur(e);

            }

        }
        if(regExp && value) {

            if(!this.mathRegExp(value)) {

                this.setState({
                    isvalid:false,
                    errortext:`Please enter a valid ${this.props.label}`
                });
                return false;
            }
            else {

                this.setState({
                    isvalid:true,
                    errortext:null
                });
                if(this.props.onBlur) {

                    this.props.onBlur(e);

                }


            }
        }
        else {
            this.setState({
                isvalid:true,
                errortext:null
            });
        }

        if(this.props.customValidation) {

            let response = this.props.customValidation(e);

            if(!response.isValid) {
                this.setState({
                    isvalid:false,
                    errortext:response.msg
                });
            }
        }



    }
    render() {
        const { id, label, onChange, isDisabled , inputAttr , noPlaceholder ,value , className, propsError, isAutoFocus, minHeight=167, characterLimit } = this.props;
        const { errortext } = this.state;
        return (
            <Fragment>
                    <div className={`${styles.textfield} ${className ? className : ''}`.trim()} data-valid={!(propsError || errortext)}>
                        { noPlaceholder && <label className={styles.textfield__label} htmlFor={id}> { label } </label> }
                        <textarea maxLength={characterLimit} style={{minHeight:minHeight}} value={value} name={id} placeholder={!noPlaceholder ? label : ''} disabled={isDisabled} className={`${styles.textfield__input}`} id={id} onChange={(e) => {onChange(validateInput(e))}} onBlur={this.checkIsValueValid} {...inputAttr} autoFocus={isAutoFocus} />
                        { (propsError || errortext) && <span className={styles.textfield__error}>{ propsError ? propsError : errortext } </span>}
                    </div>
            </Fragment>
        );
    }
}



export default UITextField;
